export const formatUSCurrency = (amount) => {
  if (amount === null || amount === undefined || amount === '') {
    return "$0.00";
  }  
  const num = typeof amount === 'string' ? parseFloat(amount) : Number(amount); 
  if (isNaN(num)) {
    return "$0.00";
  }
  const formattedWithDecimals = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
  if (formattedWithDecimals.endsWith('.00')) {
    return formattedWithDecimals.slice(0, -3); 
  }
  
  return formattedWithDecimals;
};